import {FRAME_ASPECT} from './constants.js'

// Height of an item's frame in % of the preview height
export function overlay_height (o) {
	return o.w * FRAME_ASPECT / (o.aspect || FRAME_ASPECT);
}

// Moves/resizes the item to one of the preset positions; mutates it
export function place_overlay (o, preset) {
	const margin = 3;
	const k = FRAME_ASPECT / (o.aspect || FRAME_ASPECT);
	if (preset == "full") {
		o.w = k > 1 ? 100 / k : 100;
	} else {
		if (o.w > 50) o.w = 30;
		o.w = Math.min(o.w, (100 - 2 * margin) / Math.max(k, 1));
	}
	const w = o.w;
	const h = o.w * k;
	const center = {x: (100 - w) / 2, y: (100 - h) / 2};
	const pos = {
		"full": center,
		"center": center,
		"top-left": {x: margin, y: margin},
		"top-right": {x: 100 - margin - w, y: margin},
		"bottom-left": {x: margin, y: 100 - margin - h},
		"bottom-right": {x: 100 - margin - w, y: 100 - margin - h}
	}[preset] || center;
	o.x = pos.x;
	o.y = pos.y;
}
